import { DeploymentCardProps } from '../types/deployment';

export const createNYPDeployment = (
  isLocked: boolean,
  onLockToggle: () => void,
): DeploymentCardProps => ({
  title: 'New York Post',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/New_York_Post_logo.png/960px-New_York_Post_logo.png',
  statusText: 'Changes Behind',
  statusType: 'warning',
  // newRelicStatus: 'Good',
  // newRelicType: 'success',
  lastDeploy: 'Yesterday 9:00 AM ET, Successful',
  isLocked,
  onLockToggle,
  deploymentProgress: 0,
  environment: 'production',
  changes: [],
});

export const createSunDeployment = (
  isLocked: boolean,
  onLockToggle: () => void,
): DeploymentCardProps => ({
  title: 'The Sun',
  logo: 'https://media.info/l/o/1/1571.1408913602.png',
  statusText: 'Up to Date',
  statusType: 'success',
  // newRelicStatus: 'Warning',
  // newRelicType: 'warning',
  lastDeploy: 'Today 10:20 AM ET, Successful',
  isLocked,
  onLockToggle,
  deploymentProgress: 0,
  environment: 'production',
  changes: [],
});
